module.exports = __webpack_public_path__ + "img/pGoogleW.2c24fad8.svg";